export const CreateTemplate = (dataObj) => {
  const actionBtnData = dataObj?.action ?? [];
  const themeColor = JSON.parse(dataObj.themeColor);

  let Widgets = "";
  dataObj?.widgets.forEach((widget, index) => {
    const parts = widget?.s3key?.split("/");
    let fileName = parts?.[parts?.length - 1];

    switch (widget?.type) {
      case "title":
        Widgets += ` 
        ${
          widget?.title
            ? `<div class="w-full col-span-full ">
                <div class="text-3xl font-bold w-full justify-self-stretch new-line-style theme-text-color">
                    ${widget?.title}
                </div>
            </div>`
            : ""
        }
            
        `;
        break;
      case "discription":
        Widgets += ` 
        ${
          widget?.discription
            ? `<div class="w-full col-span-full relative ">
                <div class="text-lg w-full justify-self-stretch new-line-style theme-text-color">
                  ${widget?.discription}
                </div>
            </div>`
            : ""
        }
            
        `;
        break;
      case "image":
        Widgets += ` 
                  <div class="border-radius flex justify-center items-center ">
                      <img
                      src="https://inprofile.co/${dataObj?.username}/${fileName}"
                      alt="image" 
                      class="aspect-square rounded-2xl object-cover"/>
                  </div>
      
`;
        break;
      case "card":
        Widgets += `<div class="relative animate-fade-slide-in shadow-md border-radius col-span-2
        sm:col-span-1">
        <div class="flex justify-center items-center w-full rounded-2xl">
          
            <img
              src="https://inprofile.co/${dataObj?.username}/${fileName}"
              alt="card image" 
              class="aspect-square rounded-3xl object-cover p-3"
            />

        </div>

        <div class="w-full px-4 py-3">
          <div class="editable-text text-lg font-bold new-line-style theme-text-color" style="margin-bottom:20px">
                  ${widget?.title}
          </div>
          <div class="editable-text theme-text-color text-sm new-line-style">
                 ${widget?.subTitle}
          </div>
        </div>
      </div>`;
        break;

      default:
        break;
    }
  });

  const template1 = `<!DOCTYPE html>
<html lang="en">
 <head>

    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <meta
      name="description"
      content="${dataObj?.description ?? dataObj?.title}"
    />
    ${
      dataObj?.keywords
        ? `
    <meta name="keywords" content="${dataObj?.keywords}" />
    `
        : ""
    }
    <meta name="author" content="${dataObj?.name}" />


    <meta property="og:title" content="${dataObj?.title}" />
    <meta
      property="og:description"
      content="${dataObj?.description ?? dataObj?.title}"
    />
    <meta property="og:image" content="${dataObj?.logo ?? ""}">
    <meta property="og:url" content="${
      dataObj?.url ?? "https://inprofile.co/}"
    }" />


      <link rel="canonical" href="${dataObj?.url}">
        <link rel="icon" href="${dataObj?.logo}" type="image/png">

          <meta name="facebook" content="${dataObj.socials.facebook}">
          <meta name="instagram" content="${dataObj.socials.instagram}">
          <meta name="twitter" content="${dataObj.socials.twitter}">
          <meta name="linkedin" content="${dataObj.socials.linkedin}">
          <meta name="youtube" content="${dataObj.socials.youtube}">

          <meta property="og:type" content="website">
          <meta property="og:title" content="${dataObj.title}">
          <meta property="og:description" content="${dataObj.description}">
          <meta property="og:url" content="${dataObj.url}">
          <meta property="og:image" content="${dataObj.logo}">
          <meta property="og:site_name" content="${dataObj.name}">
          <meta property="og:locale" content="en_US">

    <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="${dataObj?.title}">
  <meta name="twitter:description" content="${dataObj?.description}">
  <meta name="twitter:image" content="${dataObj?.logo}">
  <meta name="twitter:url" content="${dataObj?.url}">
    <title>${dataObj?.title}</title>


     <script src="https://cdn.tailwindcss.com"></script>
     <link
       rel="stylesheet"
       href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"
     />
     <link
       rel="stylesheet"
       href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
     />
     <link
       rel="stylesheet"
       href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css"
     />
 
     <script>
       tailwind.config = {
         theme: {
           extend: {
             colors: {
               primary: "#4ac456",
               secondary: "#fdfafa",
               "primary-varients": {
                 50: "#f2fbf3",
                 100: "#e0f8e2",
                 200: "#c3efc6",
                 300: "#94e19b",
                 400: "#4ac456",
                 500: "#38af44",
                 600: "#299034",
                 700: "#23722c",
                 800: "#205b27",
                 900: "#1c4b22",
                 950: "#0a290f",
               },
             },
           },
         },
       };

     </script>
     <style>
       .border-radius {
         border-radius: 1rem;
       }
       ::-webkit-scrollbar {
         display: none;
       }
       .social-icons-size {
         height: 1.2rem;
         width: 1.2rem;
       }
         
      .new-line-style {
        white-space: pre-line; 
        word-wrap: break-word;
        margin-top:-40px;
       }

       .theme-background-color {
       background-color:${themeColor?.background}
       }

       .theme-text-color {
       color:${themeColor?.text}
       }

       .theme-button-style{
        color:${themeColor?.btnText};
        background-color:${themeColor?.btnBg}
       }

     </style>
   </head>
  <body>
    <!-- Outer Wrapper -->
    <div class="flex md:flex-row flex-col theme-background-color">
      <!-- Profile Section -->
      <div
        class="flex flex-col items-start md:items-start sm:items-start w-full md:w-2/6 md:ps-8 md:py-8 sm:px-12 sm:py-10 p-5 md:pe-0 md:sticky md:top-0 md:h-screen md:overflow-scroll h-full"
      >
        <!-- Profile Photo Section -->
        
        ${
          dataObj?.logo
            ? `
        <div class="mb-4 block">
           <img
              src="${dataObj?.logo}"
              alt="${dataObj?.name} Logo"
              class="w-[184px] h-[184px] rounded-2xl object-cover"
            />
            </div>`
            : ""
        }

        <!-- Editable Text Fields -->
        <div class="w-full">
        ${
          dataObj?.name
            ? `<div class="text-4xl font-bold h-[57px] theme-text-color" >${dataObj?.name}</div>`
            : ""
        }
    

         ${
           dataObj?.description
             ? `<div class="text-lg new-line-style theme-text-color" >
            ${dataObj?.description}
          </div>`
             : ""
         }

          
             ${
               dataObj?.phone
                 ? `
    <a href="tel:${dataObj?.phone}" class="flex items-center mt-2">
      <i class="fa fa-solid fa-phone theme-text-color"></i>
      <p class="text-base theme-text-color ps-2">${dataObj?.phone}</p>
    </a>`
                 : ""
             }

${
  dataObj?.email
    ? `
    <a href="mailto:${dataObj?.email}" class="flex items-center">
      <i class="fa fa-solid fa-envelope theme-text-color"></i>
      <p class="text-base theme-text-color ps-2">${dataObj?.email}</p>
    </a>`
    : ""
}

        </div>

        <!-- Social Media Icons and Buttons -->
        <div class="my-4">
          <div class="w-full">
            <div class="grid grid-cols-6 gap-x-2 gap-y-1">
              <!-- Facebook Link -->
              ${
                dataObj?.socials?.facebook
                  ? `
                  <div>
                    <a
                      href="${dataObj?.socials?.facebook}"
                      target="_blank"
                      rel="noreferrer"
                      class="w-10 h-10 flex items-center justify-center rounded-lg bg-white shadow-md group transition-all duration-300"
                    >
                    <div class="h-6 w-6">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" id="facebook">
                            <path fill="#1877f2" d="M1024,512C1024,229.23016,794.76978,0,512,0S0,229.23016,0,512c0,255.554,187.231,467.37012,432,505.77777V660H302V512H432V399.2C432,270.87982,508.43854,200,625.38922,200,681.40765,200,740,210,740,210V336H675.43713C611.83508,336,592,375.46667,592,415.95728V512H734L711.3,660H592v357.77777C836.769,979.37012,1024,767.554,1024,512Z"></path>
                            <path fill="#fff" d="M711.3,660,734,512H592V415.95728C592,375.46667,611.83508,336,675.43713,336H740V210s-58.59235-10-114.61078-10C508.43854,200,432,270.87982,432,399.2V512H302V660H432v357.77777a517.39619,517.39619,0,0,0,160,0V660Z"></path>
                          </svg>
                    </div>
                    </a>
                  </div>`
                  : ""
              }
              

              <!-- Instagram Link -->

              ${
                dataObj?.socials?.instagram
                  ? `
                  <div>
                    <a
                      href="${dataObj?.socials?.instagram}"
                      target="_blank"
                      rel="noreferrer"
                      class="w-10 h-10 flex items-center justify-center rounded-lg bg-white shadow-md group transition-all duration-300"
                    >
                    <div class="h-6 w-6">
                     <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect x="2" y="2" width="28" height="28" rx="6" fill="url(#paint0_radial_87_7153)"/>
                        <rect x="2" y="2" width="28" height="28" rx="6" fill="url(#paint1_radial_87_7153)"/>
                        <rect x="2" y="2" width="28" height="28" rx="6" fill="url(#paint2_radial_87_7153)"/>
                        <path d="M23 10.5C23 11.3284 22.3284 12 21.5 12C20.6716 12 20 11.3284 20 10.5C20 9.67157 20.6716 9 21.5 9C22.3284 9 23 9.67157 23 10.5Z" fill="white"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M16 21C18.7614 21 21 18.7614 21 16C21 13.2386 18.7614 11 16 11C13.2386 11 11 13.2386 11 16C11 18.7614 13.2386 21 16 21ZM16 19C17.6569 19 19 17.6569 19 16C19 14.3431 17.6569 13 16 13C14.3431 13 13 14.3431 13 16C13 17.6569 14.3431 19 16 19Z" fill="white"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M6 15.6C6 12.2397 6 10.5595 6.65396 9.27606C7.2292 8.14708 8.14708 7.2292 9.27606 6.65396C10.5595 6 12.2397 6 15.6 6H16.4C19.7603 6 21.4405 6 22.7239 6.65396C23.8529 7.2292 24.7708 8.14708 25.346 9.27606C26 10.5595 26 12.2397 26 15.6V16.4C26 19.7603 26 21.4405 25.346 22.7239C24.7708 23.8529 23.8529 24.7708 22.7239 25.346C21.4405 26 19.7603 26 16.4 26H15.6C12.2397 26 10.5595 26 9.27606 25.346C8.14708 24.7708 7.2292 23.8529 6.65396 22.7239C6 21.4405 6 19.7603 6 16.4V15.6ZM15.6 8H16.4C18.1132 8 19.2777 8.00156 20.1779 8.0751C21.0548 8.14674 21.5032 8.27659 21.816 8.43597C22.5686 8.81947 23.1805 9.43139 23.564 10.184C23.7234 10.4968 23.8533 10.9452 23.9249 11.8221C23.9984 12.7223 24 13.8868 24 15.6V16.4C24 18.1132 23.9984 19.2777 23.9249 20.1779C23.8533 21.0548 23.7234 21.5032 23.564 21.816C23.1805 22.5686 22.5686 23.1805 21.816 23.564C21.5032 23.7234 21.0548 23.8533 20.1779 23.9249C19.2777 23.9984 18.1132 24 16.4 24H15.6C13.8868 24 12.7223 23.9984 11.8221 23.9249C10.9452 23.8533 10.4968 23.7234 10.184 23.564C9.43139 23.1805 8.81947 22.5686 8.43597 21.816C8.27659 21.5032 8.14674 21.0548 8.0751 20.1779C8.00156 19.2777 8 18.1132 8 16.4V15.6C8 13.8868 8.00156 12.7223 8.0751 11.8221C8.14674 10.9452 8.27659 10.4968 8.43597 10.184C8.81947 9.43139 9.43139 8.81947 10.184 8.43597C10.4968 8.27659 10.9452 8.14674 11.8221 8.0751C12.7223 8.00156 13.8868 8 15.6 8Z" fill="white"/>
                        <defs>
                        <radialGradient id="paint0_radial_87_7153" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(12 23) rotate(-55.3758) scale(25.5196)">
                        <stop stop-color="#B13589"/>
                        <stop offset="0.79309" stop-color="#C62F94"/>
                        <stop offset="1" stop-color="#8A3AC8"/>
                        </radialGradient>
                        <radialGradient id="paint1_radial_87_7153" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"                         gradientTransform="translate(11 31) rotate(-65.1363) scale(22.5942)">
                        <stop stop-color="#E0E8B7"/>
                        <stop offset="0.444662" stop-color="#FB8A2E"/>
                        <stop offset="0.71474" stop-color="#E2425C"/>
                        <stop offset="1" stop-color="#E2425C" stop-opacity="0"/>
                        </radialGradient>
                        <radialGradient id="paint2_radial_87_7153" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"                         gradientTransform="translate(0.500002 3) rotate(-8.1301) scale(38.8909 8.31836)">
                        <stop offset="0.156701" stop-color="#406ADC"/>
                        <stop offset="0.467799" stop-color="#6A45BE"/>
                        <stop offset="1" stop-color="#6A45BE" stop-opacity="0"/>
                        </radialGradient>
                        </defs>
                        </svg>
                    </div>
                    </a>
                  </div>`
                  : ""
              }

              <!-- X (Twitter) Link -->

              ${
                dataObj?.socials?.x
                  ? `
                  <div>
                    <a
                      href="${dataObj?.socials?.x}"
                      target="_blank"
                      rel="noreferrer"
                      class="w-10 h-10 flex items-center justify-center rounded-lg bg-white shadow-md group transition-all duration-300"
                    >
                    <div class="h-6 w-6">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 48 48" id="x-twitter">
                          <path fill="#191919" d="M36.6526 3.8078H43.3995L28.6594 20.6548L46 43.5797H32.4225L21.7881 29.6759L9.61989 43.5797H2.86886L18.6349 25.56L2 3.8078H15.9222L25.5348 16.5165L36.6526 3.8078ZM34.2846 39.5414H38.0232L13.8908 7.63406H9.87892L34.2846 39.5414Z"></path>
                        </svg>
                    </div>
                    </a>
                  </div>`
                  : ""
              }

              <!-- LinkedIn Link -->

              ${
                dataObj?.socials?.linkedin
                  ? `
                  <div>
                    <a
                      href="${dataObj?.socials?.linkedin}"
                      target="_blank"
                      rel="noreferrer"
                      class="w-10 h-10 flex items-center justify-center rounded-lg bg-white shadow-md group transition-all duration-300"
                    >
                    <div class="h-6 w-6">
                        <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 100 100" viewBox="0 0 100 100" id="linkedin">
                        <g id="Layer_2">
                        <path fill="#0077b5" d="M90.479,2.513c-14.611-0.041-68.502,0.028-80.958,0C5.645,2.513,2.5,5.562,2.5,9.317v81.381
		                    c0,3.756,3.145,6.802,7.021,6.802h80.958c3.878,0,7.021-3.046,7.021-6.803V9.317C97.5,5.562,94.357,2.513,90.479,2.513z"></path>
                        <path fill="#f1f1f1" d="M53.453 82.005c0 0 0-23.878 0-23.879-.139-4.388 2.484-8.483 7.762-8.667 5.143 0 7.201 3.921 7.201 9.67v22.875h14.214V57.485c0-13.135-7.012-19.247-16.365-19.247-7.668 0-11.036 4.285-12.907 7.204l.095-6.2H39.239c.185 4.012-.001 42.763-.001 42.763L53.453 82.005zM31.37 63.461v-24.22H17.154v42.763h14.217C31.368 77.514 31.376 67.888 31.37 63.461zM24.265 33.404c4.956 0 8.042-3.284 8.042-7.387-.041-9.897-16.004-9.787-15.991-.001C16.305 30.151 19.476 33.455 24.265 33.404z"></path>
                        </g>
                      </svg>
                    </div>
                    </a>
                  </div>`
                  : ""
              }

              <!-- YouTube Link -->

              ${
                dataObj?.socials?.youtube
                  ? `
                  <div>
                    <a
                      href="${dataObj?.socials?.youtube}"
                      target="_blank"
                      rel="noreferrer"
                      class="w-10 h-10 flex items-center justify-center rounded-lg bg-white shadow-md group transition-all duration-300"
                    >
                    <div class="h-6 w-6">
                        <svg class="rounded-md transition-all duration-300 group-hover:scale-110"
                        xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 72 72" fill="none">
                            <path
                            d="M61.1026 23.7185C60.5048 21.471 58.7363 19.6981 56.4863 19.0904C52.4181 18 36.0951 18 36.0951 18C36.0951 18 19.7805 18 15.7039 19.0904C13.4622 19.6897 11.6937 21.4627 11.0876 23.7185C10 27.7971 10 36.3124 10 36.3124C10 36.3124 10 44.8276 11.0876 48.9063C11.6854 51.1537 13.4539 52.9267 15.7039 53.5343C19.7805 54.6247 36.0951 54.6247 36.0951 54.6247C36.0951 54.6247 52.4181 54.6247 56.4863 53.5343C58.728 52.935 60.4965 51.162 61.1026 48.9063C62.1902 44.8276 62.1902 36.3124 62.1902 36.3124C62.1902 36.3124 62.1902 27.7971 61.1026 23.7185Z"
                            fill="#FF3000" />
                            <path d="M30.8811 44.1617L44.4392 36.3124L30.8811 28.463V44.1617Z" fill="white" />
                        </svg>
                    </div>
                    </a>
                  </div>`
                  : ""
              }

              <!-- Pintrest Link -->
              ${
                dataObj?.socials?.pintrest
                  ? `
                  <div>
                    <a
                      href="${dataObj?.socials?.pintrest}"
                      target="_blank"
                      rel="noreferrer"
                      class="w-10 h-10 flex items-center justify-center rounded-lg bg-white shadow-md group transition-all duration-300"
                    >
                    <div class="h-6 w-6">
                        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
	                       viewBox="0 0 511.998 511.998" xml:space="preserve">
                        <path style="fill:#D7143A;" d="M405.017,52.467C369.774,18.634,321.001,0,267.684,0C186.24,0,136.148,33.385,108.468,61.39 c-34.114,34.513-53.675,80.34-53.675,125.732c0,56.993,23.839,100.737,63.76,117.011c2.68,1.098,5.377,1.651,8.021,1.651
	                    c8.422,0,15.095-5.511,17.407-14.35c1.348-5.071,4.47-17.582,5.828-23.013c2.906-10.725,0.558-15.884-5.78-23.353
	                    c-11.546-13.662-16.923-29.817-16.923-50.842c0-62.451,46.502-128.823,132.689-128.823c68.386,0,110.866,38.868,110.866,101.434
	                    c0,39.482-8.504,76.046-23.951,102.961c-10.734,18.702-29.609,40.995-58.585,40.995c-12.53,0-23.786-5.147-30.888-14.121
	                    c-6.709-8.483-8.921-19.441-6.222-30.862c3.048-12.904,7.205-26.364,11.228-39.376c7.337-23.766,14.273-46.213,14.273-64.122
	                    c0-30.632-18.832-51.215-46.857-51.215c-35.616,0-63.519,36.174-63.519,82.354c0,22.648,6.019,39.588,8.744,46.092
	                    c-4.487,19.01-31.153,132.03-36.211,153.342c-2.925,12.441-20.543,110.705,8.618,118.54c32.764,8.803,62.051-86.899,65.032-97.713
	                    c2.416-8.795,10.869-42.052,16.049-62.495c15.817,15.235,41.284,25.535,66.064,25.535c46.715,0,88.727-21.022,118.298-59.189
	                    c28.679-37.02,44.474-88.618,44.474-145.282C457.206,127.983,438.182,84.311,405.017,52.467z"/>
                    </svg>
                    </div>
                    </a>
                  </div>`
                  : ""
              }

              <!-- Whatsapp Link -->
              ${
                dataObj?.socials?.whatsapp
                  ? `
                  <div>
                    <a
                      href="${dataObj?.socials?.whatsapp}"
                      target="_blank"
                      rel="noreferrer"
                      class="w-10 h-10 flex items-center justify-center rounded-lg bg-white shadow-md group transition-all duration-300"
                    >
                    <div class="h-6 w-6">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1219.547 1225.016" id="whatsapp">
                            <path fill="#E0E0E0" d="M1041.858 178.02C927.206 63.289 774.753.07 612.325 0 277.617 0 5.232 272.298 5.098 606.991c-.039 106.986 27.915 211.42 81.048 303.476L0 1225.016l321.898-84.406c88.689 48.368 188.547 73.855 290.166 73.896h.258.003c334.654 0 607.08-272.346 607.222-607.023.056-162.208-63.052-314.724-177.689-429.463zm-429.533 933.963h-.197c-90.578-.048-179.402-24.366-256.878-70.339l-18.438-10.93-191.021 50.083 51-186.176-12.013-19.087c-50.525-80.336-77.198-173.175-77.16-268.504.111-278.186 226.507-504.503 504.898-504.503 134.812.056 261.519 52.604 356.814 147.965 95.289 95.36 147.728 222.128 147.688 356.948-.118 278.195-226.522 504.543-504.693 504.543z"></path>
                            <linearGradient id="a" x1="609.77" x2="609.77" y1="1190.114" y2="21.084" gradientUnits="userSpaceOnUse">
                              <stop offset="0" stop-color="#20b038"></stop>
                              <stop offset="1" stop-color="#60d66a"></stop>
                            </linearGradient>
                            <path fill="url(#a)" d="M27.875 1190.114l82.211-300.18c-50.719-87.852-77.391-187.523-77.359-289.602.133-319.398 260.078-579.25 579.469-579.25 155.016.07 300.508 60.398 409.898 169.891 109.414 109.492 169.633 255.031 169.57 409.812-.133 319.406-260.094 579.281-579.445 579.281-.023 0 .016 0 0 0h-.258c-96.977-.031-192.266-24.375-276.898-70.5l-307.188 80.548z"></path>
                            <path fill="#FFF" fill-rule="evenodd" d="M462.273 349.294c-11.234-24.977-23.062-25.477-33.75-25.914-8.742-.375-18.75-.352-28.742-.352-10 0-26.25 3.758-39.992 18.766-13.75 15.008-52.5 51.289-52.5 125.078 0 73.797 53.75 145.102 61.242 155.117 7.5 10 103.758 166.266 256.203 226.383 126.695 49.961 152.477 40.023 179.977 37.523s88.734-36.273 101.234-71.297c12.5-35.016 12.5-65.031 8.75-71.305-3.75-6.25-13.75-10-28.75-17.5s-88.734-43.789-102.484-48.789-23.75-7.5-33.75 7.516c-10 15-38.727 48.773-47.477 58.773-8.75 10.023-17.5 11.273-32.5 3.773-15-7.523-63.305-23.344-120.609-74.438-44.586-39.75-74.688-88.844-83.438-103.859-8.75-15-.938-23.125 6.586-30.602 6.734-6.719 15-17.508 22.5-26.266 7.484-8.758 9.984-15.008 14.984-25.008 5-10.016 2.5-18.773-1.25-26.273s-32.898-81.67-46.234-111.326z" clip-rule="evenodd"></path>
                            <path fill="#FFF" d="M1036.898 176.091C923.562 62.677 772.859.185 612.297.114 281.43.114 12.172 269.286 12.039 600.137 12 705.896 39.633 809.13 92.156 900.13L7 1211.067l318.203-83.438c87.672 47.812 186.383 73.008 286.836 73.047h.255.003c330.812 0 600.109-269.219 600.25-600.055.055-160.343-62.328-311.108-175.649-424.53zm-424.601 923.242h-.195c-89.539-.047-177.344-24.086-253.93-69.531l-18.227-10.805-188.828 49.508 50.414-184.039-11.875-18.867c-49.945-79.414-76.312-171.188-76.273-265.422.109-274.992 223.906-498.711 499.102-498.711 133.266.055 258.516 52 352.719 146.266 94.195 94.266 146.031 219.578 145.992 352.852-.118 274.999-223.923 498.749-498.899 498.749z"></path>
                        </svg>
                    </div>
                    </a>
                  </div>`
                  : ""
              }

              <!-- Google Map Link -->
              ${
                dataObj?.socials?.googlemap
                  ? `
                  <div>
                    <a
                      href="${dataObj?.socials?.googlemap}"
                      target="_blank"
                      rel="noreferrer"
                      class="w-10 h-10 flex items-center justify-center rounded-lg bg-white shadow-md group transition-all duration-300"
                    >
                    <div class="h-6 w-6">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" id="google-maps">
                            <path fill="#4285f4" d="M25.3959 8.8345l-.0039.0038c.0837.2319.1617.4667.2285.7062C25.5527 9.3047 25.48 9.067 25.3959 8.8345zM16 2.23L8.929 5.1593 12.9916 9.222A4.2486 4.2486 0 0 1 19.0208 15.21L25 9.23l.392-.392A9.9872 9.9872 0 0 0 16 2.23z"></path>
                            <path fill="#ffba00" d="M16,16.4733A4.25,4.25,0,0,1,12.9916,9.222L8.929,5.1593A9.9683,9.9683,0,0,0,6,12.23c0,4.4057,2.2651,7.1668,4.93,10,.1787.1828.3274.3852.4959.5746l7.5608-7.5609A4.2341,4.2341,0,0,1,16,16.4733Z"></path>
                            <path fill="#0066da" d="M16,2.23a10,10,0,0,0-10,10,11.0918,11.0918,0,0,0,.5454,3.4546l12.8505-12.85A9.9563,9.9563,0,0,0,16,2.23Z"></path>
                            <path fill="#00ac47" d="M16.9011,29.12a21.83,21.83,0,0,1,4.032-6.8966C23.7976,19.3129,26,16.636,26,12.23a9.9585,9.9585,0,0,0-.6041-3.3958l-13.97,13.97A18.0436,18.0436,0,0,1,15.0173,29.08.9975.9975,0,0,0,16.9011,29.12Z"></path>
                            <path fill="#0066da" d="M10.93 22.23c.1787.1828.3274.3852.4959.5746h0C11.257 22.6155 11.1083 22.4131 10.93 22.23zM7.207 7.4637A9.9357 9.9357 0 0 0 6.45 9.2566 9.9429 9.9429 0 0 1 7.207 7.4637zM6.45 9.2566a9.9522 9.9522 0 0 0-.398 1.9513A9.9537 9.9537 0 0 1 6.45 9.2566z" opacity=".5"></path>
                            <path fill="#fff" d="M15.1957 29.3989c.02.0248.0445.0422.0664.0644C15.24 29.4411 15.2156 29.4236 15.1957 29.3989zM15.7874 29.7429l.04.0066zM13.6216 25.9269c-.0371-.067-.0679-.1382-.1059-.2047C13.5533 25.789 13.5849 25.86 13.6216 25.9269zM15.0173 29.08q-.3069-.9036-.6906-1.7566C14.5793 27.8937 14.8127 28.4771 15.0173 29.08zM15.5269 29.6563c-.0229-.0112-.0463-.0207-.0684-.0338C15.4809 29.6356 15.5036 29.6452 15.5269 29.6563zM19.7117 23.7529c-.249.3474-.4679.7125-.6927 1.0741C19.2431 24.465 19.4633 24.1006 19.7117 23.7529z"></path>
                            <polygon fill="#fff" points="23.322 19.553 23.322 19.553 23.322 19.553 23.322 19.553"></polygon>
                            <path fill="#fff" d="M17.0468 28.774h0q.3516-.887.7561-1.7428C17.5316 27.6006 17.2812 28.1826 17.0468 28.774zM18.68 25.3584c-.2879.4957-.55 1.0068-.8 1.5242C18.13 26.3647 18.3931 25.8547 18.68 25.3584z"></path>
                            <path fill="#ea4435" d="M8.929,5.1593A9.9683,9.9683,0,0,0,6,12.23a11.0918,11.0918,0,0,0,.5454,3.4546L13,9.23Z"></path>
                         </svg>
                    </div>
                    </a>
                  </div>`
                  : ""
              }

              <!-- Calendy Link -->
              ${
                dataObj?.socials?.calendly
                  ? `                         
                  <div>
                    <a
                      href="${dataObj?.socials?.calendly}"
                      target="_blank"
                      rel="noreferrer"
                      class="w-10 h-10 flex items-center justify-center rounded-lg bg-white shadow-md group transition-all duration-300"
                    >
                    <div class="h-6 w-6">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 525.8 535.73" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <defs>
                           <style>
                              .cls-1{fill:none;}.cls-2{fill:#006bff;}.cls-3{fill:#0ae9ef;}
                           </style>
                        </defs>
                        <g id="Layer_2" data-name="Layer 2">
                          <g id="Logo_assets" data-name="Logo assets">
                             <g id="Brand_mark" data-name="Brand mark">
                                 <path class="cls-1" d="M443.74,337.62l-27.16,47.05a139.52,139.52,0,0,1-120.82,69.75H241.43a139.52,139.52,0,0,1-120.82-69.75L93.45,337.62a139.52,139.52,0,0,1,0-139.51l27.16-47.05A139.53,139.53,0,0,1,241.43,81.3h54.33a139.53,139.53,0,0,1,120.82,69.76l27.16,47.05a139.23,139.23,0,0,1,8.55,17.55c0,.12.09.23.13.35a102.15,102.15,0,0,0,44.33-18.24c0-.14-.08-.28-.13-.43a237.8,237.8,0,0,0-33.29-67.58,240.67,240.67,0,0,0-52-53.48A239.3,239.3,0,0,0,98.65,437.08a239.43,239.43,0,0,0,398-98.69c.05-.15.09-.29.13-.43a102.15,102.15,0,0,0-44.33-18.24c0,.12-.09.23-.13.35A139.23,139.23,0,0,1,443.74,337.62Z">
                                </path>
                                <path class="cls-2" d="M360.4,347.4c-17,15.09-38.21,33.87-76.78,33.87h-23c-27.88,0-53.23-10.12-71.37-28.49-17.72-17.94-27.48-42.5-27.48-69.16V252.11c0-26.66,9.76-51.22,27.48-69.16,18.14-18.37,43.49-28.49,71.37-28.49h23c38.57,0,59.76,18.78,76.78,33.87,17.65,15.65,32.9,29.16,73.52,29.16a116.05,116.05,0,0,0,18.5-1.48c0-.12-.08-.23-.13-.35a139.23,139.23,0,0,0-8.55-17.55l-27.16-47.05A139.53,139.53,0,0,0,295.76,81.3H241.43a139.53,139.53,0,0,0-120.82,69.76L93.45,198.11a139.52,139.52,0,0,0,0,139.51l27.16,47.05a139.52,139.52,0,0,0,120.82,69.75h54.33a139.52,139.52,0,0,0,120.82-69.75l27.16-47.05a139.23,139.23,0,0,0,8.55-17.55c0-.12.09-.23.13-.35a116.05,116.05,0,0,0-18.5-1.48C393.3,318.24,378.05,331.75,360.4,347.4Z">
                                </path>
                                <path class="cls-2" d="M283.62,183h-23c-42.42,0-70.3,30.3-70.3,69.09v31.51c0,38.79,27.88,69.09,70.3,69.09h23c61.82,0,57-63,150.3-63a144.19,144.19,0,0,1,26.37,2.41,139.36,139.36,0,0,0,0-48.46,143.32,143.32,0,0,1-26.37,2.42C340.59,246.05,345.44,183,283.62,183Z">
                                </path>
                                <path class="cls-2" d="M513.91,315.13a130.21,130.21,0,0,0-53.62-23c0,.16-.05.32-.08.47a138.46,138.46,0,0,1-7.79,27.16A102.15,102.15,0,0,1,496.75,338c0,.14-.08.28-.13.43A237.8,237.8,0,0,1,463.33,406a240.67,240.67,0,0,1-52,53.48A239.3,239.3,0,0,1,98.65,98.65a239.43,239.43,0,0,1,398,98.69c.05.15.09.29.13.43A102.15,102.15,0,0,1,452.42,216a139.36,139.36,0,0,1,7.8,27.18c0,.15,0,.3.07.44a129.94,129.94,0,0,0,53.62-23c15.29-11.31,12.33-24.09,10-31.65C490.22,79.52,388.33,0,267.86,0,119.93,0,0,119.93,0,267.86S119.93,535.73,267.86,535.73c120.47,0,222.36-79.52,256-188.94C526.24,339.23,529.2,326.45,513.91,315.13Z">
                                </path>
                                <path class="cls-3" d="M452.42,216a116.05,116.05,0,0,1-18.5,1.48c-40.62,0-55.87-13.51-73.52-29.16-17-15.09-38.21-33.87-76.78-33.87h-23c-27.88,0-53.23,10.12-71.37,28.49-17.72,17.94-27.48,42.5-27.48,69.16v31.51c0,26.66,9.76,51.22,27.48,69.16,18.14,18.37,43.49,28.49,71.37,28.49h23c38.57,0,59.76-18.78,76.78-33.87,17.65-15.65,32.9-29.16,73.52-29.16a116.05,116.05,0,0,1,18.5,1.48,138.46,138.46,0,0,0,7.79-27.16c0-.15.06-.31.08-.47a144.19,144.19,0,0,0-26.37-2.41c-93.33,0-88.48,63-150.3,63h-23c-42.42,0-70.3-30.3-70.3-69.09V252.11c0-38.79,27.88-69.09,70.3-69.09h23c61.82,0,57,63,150.3,63a143.32,143.32,0,0,0,26.37-2.42c0-.14,0-.29-.07-.44A139.36,139.36,0,0,0,452.42,216Z">
                                </path>
                                <path class="cls-3" d="M452.42,216a116.05,116.05,0,0,1-18.5,1.48c-40.62,0-55.87-13.51-73.52-29.16-17-15.09-38.21-33.87-76.78-33.87h-23c-27.88,0-53.23,10.12-71.37,28.49-17.72,17.94-27.48,42.5-27.48,69.16v31.51c0,26.66,9.76,51.22,27.48,69.16,18.14,18.37,43.49,28.49,71.37,28.49h23c38.57,0,59.76-18.78,76.78-33.87,17.65-15.65,32.9-29.16,73.52-29.16a116.05,116.05,0,0,1,18.5,1.48,138.46,138.46,0,0,0,7.79-27.16c0-.15.06-.31.08-.47a144.19,144.19,0,0,0-26.37-2.41c-93.33,0-88.48,63-150.3,63h-23c-42.42,0-70.3-30.3-70.3-69.09V252.11c0-38.79,27.88-69.09,70.3-69.09h23c61.82,0,57,63,150.3,63a143.32,143.32,0,0,0,26.37-2.42c0-.14,0-.29-.07-.44A139.36,139.36,0,0,0,452.42,216Z">
                                </path>
                              </g>
                              </g>
                            </g>
                       </svg>
                    </div>
                    </a>
                  </div>`
                  : ""
              }

              <!-- Tiktok Link -->
              ${
                dataObj?.socials?.tiktok
                  ? `
                  <div>
                    <a
                      href="${dataObj?.socials?.tiktok}"
                      target="_blank"
                      rel="noreferrer"
                      class="w-10 h-10 flex items-center justify-center rounded-lg bg-white shadow-md group transition-all duration-300"
                    >
                    <div class="h-6 w-6">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 54 54" id="tiktok">
                          <g>
                            <path fill="#e71d40" d="M8.52,36.36a14.66,14.66,0,1,0,29.32.14l.08-16.41L40,21.23a18.22,18.22,0,0,0,8.67,2.21l0-7.72A10.81,10.81,0,0,1,38,4.86l-7.72,0-.15,31.64a6.95,6.95,0,1,1-6.92-7l0-7.71A14.67,14.67,0,0,0,8.52,36.36Z"></path>
                            <path fill="#40d8ff" d="M6.61,34.42a14.66,14.66,0,1,0,29.32.15L36,18.16l2.11,1.14a18.17,18.17,0,0,0,8.68,2.2l0-7.71A10.81,10.81,0,0,1,36.09,2.93l-7.72,0-.16,31.64a6.95,6.95,0,1,1-6.91-7l0-7.71A14.67,14.67,0,0,0,6.61,34.42Z"></path>
                            <path fill="#1c1c1c" d="M46.8,21.5l0-6a10.89,10.89,0,0,1-6.6-4,10.87,10.87,0,0,1-4-6.64l-6,0-.15,31.64a6.94,6.94,0,0,1-12.74,3.79,6.94,6.94,0,0,1,3.91-12.7l0-5.67a14.65,14.65,0,0,0-9.47,23.85A14.65,14.65,0,0,0,35.93,34.57L36,18.16l2.11,1.14A18.17,18.17,0,0,0,46.8,21.5Z"></path>
                          </g>
                      </svg>
                    </div>
                    </a>
                  </div>`
                  : ""
              }
              <!-- Reddit Link -->
              ${
                dataObj?.socials?.reddit
                  ? `
                  <div>
                    <a
                      href="${dataObj?.socials?.reddit}"
                      target="_blank"
                      rel="noreferrer"
                      class="w-10 h-10 flex items-center justify-center rounded-lg bg-white shadow-md group transition-all duration-300"
                    >
                    <div class="h-6 w-6">
                        <svg xmlns="http://www.w3.org/2000/svg" aria-label="Reddit" viewBox="0 0 512 512" id="reddit">
                          <rect width="512" height="512" fill="#f40" rx="15%"></rect>
                              <g fill="#fff">
                                  <ellipse cx="256" cy="307" rx="166" ry="117"></ellipse>
                                  <circle cx="106" cy="256" r="42"></circle>
                                  <circle cx="407" cy="256" r="42"></circle>
                                  <circle cx="375" cy="114" r="32"></circle>
                              </g>
                              <g fill="none" stroke-linecap="round" stroke-linejoin="round">
                              <path stroke="#fff" stroke-width="16" d="m256 196 23-101 73 15"></path>
                              <path stroke="#f40" stroke-width="13" d="m191 359c33 25 97 26 130 0"></path>
                              </g>
                              <g fill="#f40">
                              <circle cx="191" cy="287" r="31"></circle>
                              <circle cx="321" cy="287" r="31"></circle>
                              </g>
                         </svg>
                    </div>
                    </a>
                  </div>`
                  : ""
              }
              <!-- Buy me a cofee Link -->
              ${
                dataObj?.socials?.buymeacoffe
                  ? `
                  <div>
                    <a
                      href="${dataObj?.socials?.buymeacoffe}"
                      target="_blank"
                      rel="noreferrer"
                      class="w-10 h-10 flex items-center justify-center rounded-lg bg-white shadow-md group transition-all duration-300"
                    >
                    <div class="h-4 w-4">
                        <svg viewBox="0 0 884 1279" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M791.109 297.518L790.231 297.002L788.201 296.383C789.018 297.072 790.04 297.472 791.109 297.518V297.518Z" fill="#0D0C22"/>
                              <path d="M803.896 388.891L802.916 389.166L803.896 388.891Z" fill="#0D0C22"/>
                              <path d="M791.484 297.377C791.359 297.361 791.237 297.332 791.118 297.29C791.111 297.371 791.111 297.453 791.118 297.534C791.252 297.516 791.379 297.462 791.484 297.377V297.377Z" fill="#0D0C22"/>
                              <path d="M791.113 297.529H791.244V297.447L791.113 297.529Z" fill="#0D0C22"/>
                              <path d="M803.111 388.726L804.591 387.883L805.142 387.573L805.641 387.04C804.702 387.444 803.846 388.016 803.111 388.726V388.726Z" fill="#0D0C22"/>
                              <path d="M793.669 299.515L792.223 298.138L791.243 297.605C791.77 298.535 792.641 299.221 793.669 299.515V299.515Z" fill="#0D0C22"/>
                              <path d="M430.019 1186.18C428.864 1186.68 427.852 1187.46 427.076 1188.45L427.988 1187.87C428.608 1187.3 429.485 1186.63 430.019 1186.18Z" fill="#0D0C22"/>
                              <path d="M641.187 1144.63C641.187 1143.33 640.551 1143.57 640.705 1148.21C640.705 1147.84 640.86 1147.46 640.929 1147.1C641.015 1146.27 641.084 1145.46 641.187 1144.63Z" fill="#0D0C22"/>
                              <path d="M619.284 1186.18C618.129 1186.68 617.118 1187.46 616.342 1188.45L617.254 1187.87C617.873 1187.3 618.751 1186.63 619.284 1186.18Z" fill="#0D0C22"/>
                              <path d="M281.304 1196.06C280.427 1195.3 279.354 1194.8 278.207 1194.61C279.136 1195.06 280.065 1195.51 280.684 1195.85L281.304 1196.06Z" fill="#0D0C22"/>
                              <path d="M247.841 1164.01C247.704 1162.66 247.288 1161.35 246.619 1160.16C247.093 1161.39 247.489 1162.66 247.806 1163.94L247.841 1164.01Z" fill="#0D0C22"/>
                              <path d="M472.623 590.836C426.682 610.503 374.546 632.802 306.976 632.802C278.71 632.746 250.58 628.868 223.353 621.274L270.086 1101.08C271.74 1121.13 280.876 1139.83 295.679 1153.46C310.482 1167.09 329.87 1174.65 349.992 1174.65C349.992 1174.65 416.254 1178.09 438.365 1178.09C462.161 1178.09 533.516 1174.65 533.516 1174.65C553.636 1174.65 573.019 1167.08 587.819 1153.45C602.619 1139.82 611.752 1121.13 613.406 1101.08L663.459 570.876C641.091 563.237 618.516 558.161 593.068 558.161C549.054 558.144 513.591 573.303 472.623 590.836Z" fill="#FFDD00"/>
                              <path d="M78.6885 386.132L79.4799 386.872L79.9962 387.182C79.5987 386.787 79.1603 386.435 78.6885 386.132V386.132Z" fill="#0D0C22"/>
                              <path d="M879.567 341.849L872.53 306.352C866.215 274.503 851.882 244.409 819.19 232.898C808.711 229.215 796.821 227.633 788.786 220.01C780.751 212.388 778.376 200.55 776.518 189.572C773.076 169.423 769.842 149.257 766.314 129.143C763.269 111.85 760.86 92.4243 752.928 76.56C742.604 55.2584 721.182 42.8009 699.88 34.559C688.965 30.4844 677.826 27.0375 666.517 24.2352C613.297 10.1947 557.342 5.03277 502.591 2.09047C436.875 -1.53577 370.983 -0.443234 305.422 5.35968C256.625 9.79894 205.229 15.1674 158.858 32.0469C141.91 38.224 124.445 45.6399 111.558 58.7341C95.7448 74.8221 90.5829 99.7026 102.128 119.765C110.336 134.012 124.239 144.078 138.985 150.737C158.192 159.317 178.251 165.846 198.829 170.215C256.126 182.879 315.471 187.851 374.007 189.968C438.887 192.586 503.87 190.464 568.44 183.618C584.408 181.863 600.347 179.758 616.257 177.304C634.995 174.43 647.022 149.928 641.499 132.859C634.891 112.453 617.134 104.538 597.055 107.618C594.095 108.082 591.153 108.512 588.193 108.942L586.06 109.252C579.257 110.113 572.455 110.915 565.653 111.661C551.601 113.175 537.515 114.414 523.394 115.378C491.768 117.58 460.057 118.595 428.363 118.647C397.219 118.647 366.058 117.769 334.983 115.722C320.805 114.793 306.661 113.611 292.552 112.177C286.134 111.506 279.733 110.801 273.333 110.009L267.241 109.235L265.917 109.046L259.602 108.134C246.697 106.189 233.792 103.953 221.025 101.251C219.737 100.965 218.584 100.249 217.758 99.2193C216.932 98.1901 216.482 96.9099 216.482 95.5903C216.482 94.2706 216.932 92.9904 217.758 91.9612C218.584 90.9319 219.737 90.2152 221.025 89.9293H221.266C232.33 87.5721 243.479 85.5589 254.663 83.8038C258.392 83.2188 262.131 82.6453 265.882 82.0832H265.985C272.988 81.6186 280.026 80.3625 286.994 79.5366C347.624 73.2302 408.614 71.0801 469.538 73.1014C499.115 73.9618 528.676 75.6996 558.116 78.6935C564.448 79.3474 570.746 80.0357 577.043 80.8099C579.452 81.1025 581.878 81.4465 584.305 81.7391L589.191 82.4445C603.438 84.5667 617.61 87.1419 631.708 90.1703C652.597 94.7128 679.422 96.1925 688.713 119.077C691.673 126.338 693.015 134.408 694.649 142.03L696.731 151.752C696.786 151.926 696.826 152.105 696.852 152.285C701.773 175.227 706.7 198.169 711.632 221.111C711.994 222.806 712.002 224.557 711.657 226.255C711.312 227.954 710.621 229.562 709.626 230.982C708.632 232.401 707.355 233.6 705.877 234.504C704.398 235.408 702.75 235.997 701.033 236.236H700.895L697.884 236.649L694.908 237.044C685.478 238.272 676.038 239.419 666.586 240.486C647.968 242.608 629.322 244.443 610.648 245.992C573.539 249.077 536.356 251.102 499.098 252.066C480.114 252.57 461.135 252.806 442.162 252.771C366.643 252.712 291.189 248.322 216.173 239.625C208.051 238.662 199.93 237.629 191.808 236.58C198.106 237.389 187.231 235.96 185.029 235.651C179.867 234.928 174.705 234.177 169.543 233.397C152.216 230.798 134.993 227.598 117.7 224.793C96.7944 221.352 76.8005 223.073 57.8906 233.397C42.3685 241.891 29.8055 254.916 21.8776 270.735C13.7217 287.597 11.2956 305.956 7.64786 324.075C4.00009 342.193 -1.67805 361.688 0.472751 380.288C5.10128 420.431 33.165 453.054 73.5313 460.35C111.506 467.232 149.687 472.807 187.971 477.556C338.361 495.975 490.294 498.178 641.155 484.129C653.44 482.982 665.708 481.732 677.959 480.378C681.786 479.958 685.658 480.398 689.292 481.668C692.926 482.938 696.23 485.005 698.962 487.717C701.694 490.429 703.784 493.718 705.08 497.342C706.377 500.967 706.846 504.836 706.453 508.665L702.633 545.797C694.936 620.828 687.239 695.854 679.542 770.874C671.513 849.657 663.431 928.434 655.298 1007.2C653.004 1029.39 650.71 1051.57 648.416 1073.74C646.213 1095.58 645.904 1118.1 641.757 1139.68C635.218 1173.61 612.248 1194.45 578.73 1202.07C548.022 1209.06 516.652 1212.73 485.161 1213.01C450.249 1213.2 415.355 1211.65 380.443 1211.84C343.173 1212.05 297.525 1208.61 268.756 1180.87C243.479 1156.51 239.986 1118.36 236.545 1085.37C231.957 1041.7 227.409 998.039 222.9 954.381L197.607 711.615L181.244 554.538C180.968 551.94 180.693 549.376 180.435 546.76C178.473 528.023 165.207 509.681 144.301 510.627C126.407 511.418 106.069 526.629 108.168 546.76L120.298 663.214L145.385 904.104C152.532 972.528 159.661 1040.96 166.773 1109.41C168.15 1122.52 169.44 1135.67 170.885 1148.78C178.749 1220.43 233.465 1259.04 301.224 1269.91C340.799 1276.28 381.337 1277.59 421.497 1278.24C472.979 1279.07 524.977 1281.05 575.615 1271.72C650.653 1257.95 706.952 1207.85 714.987 1130.13C717.282 1107.69 719.576 1085.25 721.87 1062.8C729.498 988.559 737.115 914.313 744.72 840.061L769.601 597.451L781.009 486.263C781.577 480.749 783.905 475.565 787.649 471.478C791.392 467.391 796.352 464.617 801.794 463.567C823.25 459.386 843.761 452.245 859.023 435.916C883.318 409.918 888.153 376.021 879.567 341.849ZM72.4301 365.835C72.757 365.68 72.1548 368.484 71.8967 369.792C71.8451 367.813 71.9483 366.058 72.4301 365.835ZM74.5121 381.94C74.6842 381.819 75.2003 382.508 75.7337 383.334C74.925 382.576 74.4089 382.009 74.4949 381.94H74.5121ZM76.5597 384.641C77.2996 385.897 77.6953 386.689 76.5597 384.641V384.641ZM80.672 387.979H80.7752C80.7752 388.1 80.9645 388.22 81.0333 388.341C80.9192 388.208 80.7925 388.087 80.6548 387.979H80.672ZM800.796 382.989C793.088 390.319 781.473 393.726 769.996 395.43C641.292 414.529 510.713 424.199 380.597 419.932C287.476 416.749 195.336 406.407 103.144 393.382C94.1102 392.109 84.3197 390.457 78.1082 383.798C66.4078 371.237 72.1548 345.944 75.2003 330.768C77.9878 316.865 83.3218 298.334 99.8572 296.355C125.667 293.327 155.64 304.218 181.175 308.09C211.917 312.781 242.774 316.538 273.745 319.36C405.925 331.405 540.325 329.529 671.92 311.91C695.905 308.686 719.805 304.941 743.619 300.674C764.835 296.871 788.356 289.731 801.175 311.703C809.967 326.673 811.137 346.701 809.778 363.615C809.359 370.984 806.139 377.915 800.779 382.989H800.796Z" fill="#0D0C22"/>
                          </svg>
                    </div>
                    </a>
                  </div>`
                  : ""
              }
            </div>
          </div>
        </div>
        <div class="mt-4 grid grid-rows-1 gap-3 w-full">

        ${actionBtnData
          ?.map((item) => {
            return `
            <a href="${item?.link}" target="_blank">
                <button  class="px-3 py-1.5 theme-button-style rounded-lg w-full lg:w-72">
                  ${item?.name}
                </button>
            </a>`;
          })
          .join("")}
      
        </div>
      </div>

      <!-- Widgets Section -->
      <div
        class="flex flex-col items-start md:w-4/6 w-full md:pe-8 md:py-8 sm:p-8 sm:pe-12 sm:py-10 p-5"
      >
        <!-- Replace this with the actual widgets component -->
        <div class="w-full">
          <!-- Grid layout for the widgets -->
          <div class="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-x-3 sm:gap-x-5 gap-y-5">${Widgets}</div>
        </div>
      </div>



       <!-- Create Inprofile Button -->
      <div class="fixed bottom-4 z-50 right-4">

   <a href="https://inprofile.co/"  target="_blank" class="relative inline-flex items-center justify-start px-3 py-1 overflow-hidden font-medium transition-all bg-black rounded-lg group">
    <span class="absolute top-0 right-0 inline-block w-4 h-4 transition-all duration-500 ease-in-out bg-primary-varients-300 rounded group-hover:-mr-4 group-hover:-mt-4">
        <span class="absolute top-0 right-0 w-5 h-5 rotate-45 translate-x-1/2 -translate-y-1/2 bg-white"></span>
    </span>
    <span class="absolute bottom-0 left-0 w-full h-full transition-all duration-500 ease-in-out delay-200 -translate-x-full translate-y-full rounded-2xl group-hover:mb-12 group-hover:translate-x-0"></span>
    <span class="relative w-full text-left text-white transition-colors duration-200 ease-in-out group-hover:text-white">Create your InProfile</span>
</a>
      </div>
    </div>
  </body>
</html>
`;

  return template1;
};
